import { Flex, rwd, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PurchaseCardsGroup = styled(Flex)`
  gap: ${Spacing.S32};
  justify-content: space-evenly;
  width: 100%;

  ${rwd.equalOrLessThan('medium')} {
    align-items: center;
    flex-direction: column;
  }
`
